import { AbstractModel } from '../abstract.model';
import { Geometry } from 'geojson';
import { MarkerGeometry } from '../map/map.service';

export class IFlag extends AbstractModel {
  targetObjectId: string;
  targetObjectType: 'mapObject' | 'notification' | 'diary';
  global: boolean;
  userId: string;
  groupId?: string;
  layerId?: string;
  geometry?: MarkerGeometry;

  constructor() {
    super();
    this.id = null;
  }
}
